import { useState, useEffect } from 'react';
import { loadStripe, Stripe } from '@stripe/stripe-js';

export default function useStripe() {
  const [stripe, setStripe] = useState<Stripe | null>(null);
  const stripeKey = window.Bonjoro?.stripeKey ?? '';

  const loadStripeAsync = async () => {
    setStripe(await loadStripe(stripeKey));
  };

  useEffect(() => {
    loadStripeAsync();
  }, []);

  return stripe;
}
